import ServiceLanding from "../components/services/ServiceLanding";

export default function Webapp() {
  return <ServiceLanding service="webapp" />;
}
